import { FormattedMessage } from 'react-intl';
import { Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { COLORS } from 'theme/MainTheme';
import clsx from 'clsx';

const useStyles = makeStyles(() => ({
  rightButton: {
    marginLeft: 20,
  },
  selectedButton: {
    backgroundColor: COLORS.BLUE,
    color: COLORS.WHITE,

    '&:hover': {
      backgroundColor: COLORS.BLUE,
    },

    '&.Mui-disabled': {
      backgroundColor: COLORS.BLUE,
      color: COLORS.WHITE,
    },
  },
}), { name: 'SelectedButton' });

export type SelectedButtonProps = {
  value: boolean;
  disabled: boolean;
  labelId: string;
  onClick: () => void;
};

const SelectedButton = ({ value, disabled, labelId, onClick } : SelectedButtonProps) : JSX.Element => {
  const classes = useStyles();

  const className = clsx([
    classes.selectedButton,
    !value && classes.rightButton,
  ]);

  return (
    <Button
      className={className}
      disabled={disabled}
      variant="contained"
      onClick={onClick}
    >
      <FormattedMessage id={labelId} />
    </Button>
  );
}

export default SelectedButton;